import { REGION_CITY_ROWS } from '../data/regionsCatalog';
import { slugifyRegion } from '../utils/regionSlugs';
import { localizedPrimaryCityLabel } from '../lib/regionDisplay';
import { normalizeLangKey } from '../lib/localeLangKey';

const REGION_ALIASES = {
  da_nang: 'danang',
  ho_chi_minh: 'hochiminh',
  hcmc: 'hochiminh',
  saigon: 'hochiminh',
  ha_noi: 'hanoi',
  hoi_an: 'hoian',
  nha_trang: 'nhatrang',
  da_lat: 'dalat',
  phu_quoc: 'phuquoc',
  kuala_lumpur: 'kualalumpur',
  kota_kinabalu: 'kotakinabalu',
  new_york: 'newyork',
  los_angeles: 'losangeles',
  san_francisco: 'sanfrancisco',
};

/** region slug / pick / alias → Korean label */
export const REGION_LABELS = (() => {
  const out = {};
  for (const row of REGION_CITY_ROWS) {
    out[row.key] = row.ko;
    out[slugifyRegion(row.pick)] = row.ko;
  }
  for (const [alias, key] of Object.entries(REGION_ALIASES)) {
    const row = REGION_CITY_ROWS.find((r) => r.key === key);
    if (row) out[alias] = row.ko;
  }
  return out;
})();

/**
 * @param {string|null|undefined} region businesses.region or slug
 * @param {string} [language]
 */
export function getRegionLabel(region, language = 'ko') {
  const lang = normalizeLangKey(language);
  const raw = String(region || '').trim();
  if (!raw) return '';
  const lower = raw.toLowerCase();
  const slug = slugifyRegion(raw);
  const row =
    REGION_CITY_ROWS.find((r) => r.key === lower || r.key === slug || slugifyRegion(r.pick) === slug) ||
    REGION_CITY_ROWS.find((r) => REGION_ALIASES[lower] && r.key === REGION_ALIASES[lower]);
  if (row) return localizedPrimaryCityLabel(row.pick, lang) || (lang === 'ko' ? row.ko : row.pick);
  if (lang === 'ko' && REGION_LABELS[lower]) return REGION_LABELS[lower];
  if (lang === 'ko' && REGION_LABELS[slug]) return REGION_LABELS[slug];
  return raw;
}
